import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch(customerId, reasonId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customerKnowledge (
            reason_id: ${reasonId},
            customer_id: ${customerId},
          ) {
            id,
            customer_id,
            reason_id,
            title,
            observation,
            reason_option {
              id,
              label,
              value,
              type,
              option_item_id
            }
          }
        }
      `
    })
  },
  add(args){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createCustomerKnowledge (
            customer_id: ${args.id},
            reason_id: ${args.reasonId},
            observation: """${args.observation}""",
            reason_responses_attributes: ` + JSON.stringify(args.reason_responses).replaceAll(/"([a-zA-Z-_]+)":/g, "$1:").replace(/^\{/, '').replace(/\}$/, '') + `
          ) {
            id
          }
        }
      `
    })
  }
}
